import { http } from './config';

const CLIENTES_PATH = 'clientes';

export default {
  listar: object => {
    let params = `page=${object.page ? object.page : 1}`;
    if (object.id) {
      params += `&id=${object.id}`;
    }
    if (object.nome) {
      params += `&nome=${object.nome}`;
    }
    return http.get(`${CLIENTES_PATH}?${params}`);
  },
  deletar: cliente => http.delete(`${CLIENTES_PATH}/${cliente._id}`),
  atualizar: cliente => http.post(`${CLIENTES_PATH}/${cliente._id}`, cliente),
  getByCodigo: codigo => http.get(`${CLIENTES_PATH}/${codigo}`),
  salvar: cliente => http.post(CLIENTES_PATH, cliente),
  enviarRelatorioGeracaoMensal: cliente =>
    http.post(`${CLIENTES_PATH}/${cliente._id}/enviar-relatorio-mensal`, {})
};
